try {

window.$ = window.jQuery = require('jquery');

require('./zepto.js')
require('fittext.js')

} catch (e) {
    console.log(e)
}



